import React from 'react';
import { Bar } from 'react-chartjs-2';
import { Empty } from '@buildoutinc/blueprint-react/ui/Empty';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons';
import { NonBasicCardStyling } from './util';

type ReferralSource = {
  sourceName: string;
  sourceCount: number;
};

export type Props = {
  referralCountBySource: ReferralSource[];
};

export default function ReferralSourceCard({ referralCountBySource }: Props) {
  const barData = {
    labels: referralCountBySource.map(source => source.sourceName),
    datasets: [
      {
        data: referralCountBySource.map(source => source.sourceCount),
        backgroundColor: '#2968E7',
      },
    ],
  };

  const maxCount = referralCountBySource.length > 0 ? Math.max(...barData['datasets'][0]['data']) : 0;

  const yAxisTickOptions = {
    beginAtZero: true,
    fontColor: '#8E93A4',
    maxTicksLimit: 7,
    padding: 10,
    // Only set stepSize if maxCount is less than 3 to avoid floating point issues
    ...(maxCount < 3 ? { stepSize: 1 } : {}),
  };

  const barOptions = {
    hover: { mode: null },
    legend: { display: false },
    maintainAspectRatio: false,
    responsive: true,
    scales: {
      xAxes: [
        {
          stacked: true,
          ticks: {
            fontColor: '#8E93A4',
            fontSize: 9,
            maxRotation: 0, // Prevent rotation of x-axis labels
            minRotation: 0,
          },
          gridLines: {
            color: '#D8DADF',
            display: false,
          },
        },
      ],
      yAxes: [
        {
          stacked: true,
          ticks: yAxisTickOptions,
          gridLines: {
            color: '#D8DADF',
            drawBorder: false,
            drawTicks: false,
            offset: true,
            zeroLineColor: '#D8DADF',
          },
        },
      ],
    },
    tooltips: { enabled: false }
  };

  function contentForCard() {
    return (
      <>
        <div style={{ width: '100%', height: '100%' }}>
          <Bar data={barData} options={barOptions} />
        </div>
      </>
    );
  }

  return (
    <div className={NonBasicCardStyling}>
      <div className="d-flex justify-content-between align-items-center">
        <h6 className="m-0 fw-normal">Top Lead Sources</h6>
      </div>
      {referralCountBySource.length > 0 ? (
        contentForCard()
      ) : (
        <Empty className="bg-white" style={{ minHeight: '250px' }}>
          <Empty.Media>
            <FontAwesomeIcon icon={faExclamationCircle} />
          </Empty.Media>
          <Empty.Title>No referral source data to display</Empty.Title>
          <Empty.Content>Waiting For Data...</Empty.Content>
        </Empty>
      )}
    </div>
  );
}
